var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPen = function SvgIconPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m3.321 18.16 4.42-.884a.834.834 0 0 0 .426-.228l5.541-5.541a.833.833 0 0 0 0-1.179l-3.535-3.535a.833.833 0 0 0-1.179 0l-5.541 5.541a.833.833 0 0 0-.228.426l-.884 4.42a.833.833 0 0 0 .98.98ZM16.827 4.852 15.65 3.674a2.5 2.5 0 0 0-3.536 0l-.821.82a.833.833 0 0 0 0 1.18l3.536 3.535a.833.833 0 0 0 1.178 0l.821-.821a2.5 2.5 0 0 0 0-3.536Z"
  })));
};
export default SvgIconPen;